import * as S from './CommonSubscriptionSideSection.styles';
import useCurrentBreakpoint from '@britishcouncil/react-extro-ui/dist/hooks/useCurrentBreakpoint';
import { TimerSection, TimerSectionProps } from '../../../timer';
import PlanSummary, { PlanSummaryProps } from '../../../summary/planSummary/PlanSummary';
import { DiscountInfo } from '../../../summary/planSummary/components';
import ErrorSummaryMessage from '../../../errorSummary/ErrorSummaryMessage';
import { useErrorSummaryContext } from '../../../../contexts';

interface CommonSubscriptionSideSectionProps {
  timer?: TimerSectionProps;
  planSummary?: PlanSummaryProps;
  discountInfo?: DiscountInfo;
  isUpdatingPaymentMethod?: boolean;
}

const CommonSubscriptionSideSection = ({
  timer,
  planSummary,
  discountInfo,
  isUpdatingPaymentMethod,
}: CommonSubscriptionSideSectionProps) => {
  const breakpoint = useCurrentBreakpoint();
  const { isErrorSummaryMessageVisible } = useErrorSummaryContext();

  if (breakpoint === 'lg') {
    return (
      <S.StickyRoot className="sticky">
        {isErrorSummaryMessageVisible && <ErrorSummaryMessage />}
        {timer && <TimerSection {...timer} />}
        {planSummary && (
          <PlanSummary
            {...planSummary}
            discountInfo={discountInfo}
            isUpdatingPaymentMethod={isUpdatingPaymentMethod}
          />
        )}
      </S.StickyRoot>
    );
  }

  return (
    <>
      <S.StickyRoot className="sticky">
        {isErrorSummaryMessageVisible && <ErrorSummaryMessage />}
        {timer && <TimerSection {...timer} />}
      </S.StickyRoot>
      <S.Root>
        {planSummary && (
          <PlanSummary
            {...planSummary}
            discountInfo={discountInfo}
            isUpdatingPaymentMethod={isUpdatingPaymentMethod}
          />
        )}
      </S.Root>
    </>
  );
};

export default CommonSubscriptionSideSection;
